// extracted by mini-css-extract-plugin
export default {"title":"AddSite_title__JUueH","boxForm":"AddSite_boxForm__-+s7J","form":"AddSite_form__OOjTe"};